import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './stores/auth.js';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/connexion/verifier/:token',
    name: 'verifier',
    component: () => import('./views/VerifierView.vue'),
    meta: { public: true },
    props: true,
  },
  {
    path: '/',
    component: () => import('./components/AppShell.vue'),
    children: [
      { path: '',                  redirect: '/tenants' },
      { path: 'tenants',           name: 'tenants',         component: () => import('./views/TenantsListView.vue') },
      { path: 'tenants/new',       name: 'tenants-new',     component: () => import('./views/OnboardWizardView.vue') },
      { path: 'tenants/:id',       name: 'tenant-detail',   component: () => import('./views/TenantDetailView.vue'), props: true },
      { path: 'audit',             name: 'audit',           component: () => import('./views/AuditListView.vue') },
      { path: 'audit/:id',         name: 'audit-detail',    component: () => import('./views/AuditDetailView.vue'), props: true },
      { path: 'schedules',         name: 'schedules',       component: () => import('./views/SchedulesView.vue') },
      { path: 'usage',             name: 'usage',           component: () => import('./views/UsageView.vue') },
      { path: 'topics',            name: 'topics',          component: () => import('./views/TopicsView.vue') },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  // Pick up token from URL on first navigation too (handles direct landing on a deep route)
  if (!auth.token) auth.bootFromUrl();

  if (to.meta.public) return true;

  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }

  // Lazy-fetch admin profile once per session
  if (!auth.admin) {
    const me = await auth.fetchMe();
    if (!me) return { name: 'login' };
  }

  return true;
});

export default router;
